import { collection, doc, getDoc, getDocs, limit, orderBy, query, serverTimestamp, startAfter, Timestamp, updateDoc, where } from "firebase/firestore";
import { meetingsCollection } from "../models/meetingModel";
import { db } from "../../firebase/firebase";
import moment from "moment";
function formatDuration(minutes) {
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (hrs && mins) return `${hrs} hour${hrs > 1 ? 's' : ''} ${mins} minute${mins > 1 ? 's' : ''}`;
  if (hrs) return `${hrs} hour${hrs > 1 ? 's' : ''}`;
  if (mins) return `${mins} minute${mins > 1 ? 's' : ''}`;
  return "0 minutes";
}
export const getAllMeetings = async ({
  limitCount = 10,
  sortBy = "lastModifiedTimestamp",
  meetingPersonId = "",
  assigneeId = "",
  startDate = "",
  endDate = "",
  status = "",
  initialInfoMedium = "",
  finalInfoMedium = "",
  startAfterdoc = null
}) => {
  let queryConstraints = [];

  const baseWhere = where("isEvent", "==", false);
    queryConstraints.push(baseWhere);
 if (meetingPersonId) {
  const meetingPersonRef = doc(db, "contactPersons", meetingPersonId);
  queryConstraints.push(where("contactPerson", "==", meetingPersonRef));
}

if (assigneeId) {
  const assigneeRef = doc(db, "users", assigneeId);
  queryConstraints.push(where("responsiblePerson", "==", assigneeRef));
}

if (initialInfoMedium) {
  queryConstraints.push(where("initialMeetingInformationMedium", "==", initialInfoMedium));
}

if (finalInfoMedium) {
  queryConstraints.push(where("finalMeetingInformationMedium", "==", finalInfoMedium));
}


function parseDDMMYYYY(dateStr) {
  const [day, month, year] = dateStr.split("-");
  return new Date(`${year}-${month}-${day}`);
}
//  if (startDate && endDate) {
//   const start = parseDDMMYYYY(startDate);
//   const end = parseDDMMYYYY(endDate);

//   queryConstraints.push(
//     where("meetingStartTimestamp", ">", start),
//     where("meetingStartTimestamp", "<=", end)
//   );
// }

let orderByField = sortBy;

if (startDate && endDate) {
  const startTimestamp = Timestamp.fromDate(
    moment(startDate, "MM-DD-YYYY").utcOffset("+05:30").startOf("day").toDate()
  );
  const endTimestamp = Timestamp.fromDate(
moment(endDate, "MM-DD-YYYY").utcOffset("+05:30").endOf("day").toDate());
  queryConstraints.push(
    where("meetingStartTimestamp", ">", startTimestamp),
    where("meetingStartTimestamp", "<=", endTimestamp)
  );
  orderByField = "meetingStartTimestamp";
}

  if (status) {
    queryConstraints.push(where("meetingStatus", "==", status)); // ✅ fixed typo
  }

  queryConstraints.push(orderBy(orderByField, "desc"));
  queryConstraints.push(limit(limitCount));

  if (startAfterdoc) {
    const startRef = doc(db, "meetings", startAfterdoc);
    const startSnap = await getDoc(startRef);
    queryConstraints.push(startAfter(startSnap));
  }

  const baseQuery = query(meetingsCollection, ...queryConstraints);
  const snapshot = await getDocs(baseQuery);

  const meetings = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const formattedMeetings = await Promise.all(
  meetings.map(async (meeting) => {
    const {
      contactPerson,
      responsiblePerson,
      meetingStartTimestamp,
      meetingEndTimestamp,
      meetingDurationInMinutes,
      meetingStatus,
      title,
      meetingPlace,
      meetingDescription,
      closureNotes,
      meetingIncharge,
      initialMeetingInformationMedium,
      finalMeetingInformationMedium
    } = meeting;

const contactSnap = contactPerson ? await getDoc(contactPerson) : null;
    const assigneeSnap = responsiblePerson ? await getDoc(responsiblePerson) : null;

    const contactName = contactSnap?.exists() ? contactSnap.data().name : "Unknown";
    const assigneeData = assigneeSnap?.exists() ? assigneeSnap.data() : null;

const assignee = assigneeData
  ? {
      name: assigneeData.name || "Unknown",
      id: assigneeSnap.id,
    }
  : {
      name: "Unknown",
      id: "",
    };


    const start = meetingStartTimestamp.toDate();
    const end = meetingEndTimestamp.toDate();

    const meetingDate = start.toLocaleDateString("en-GB");

    const startTime = start.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const endTime = end.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const durationInMinutes = formatDuration(meetingDurationInMinutes)

    return {
      id: meeting.id,
      title,
      contactPerson: contactName,
      assignee,
      meetingDate,
      meetingDuration: `${startTime} - ${endTime}`,
      durationInMinutes: durationInMinutes,
      status: meetingStatus,
      meetingPlace,
      meetingDescription,
      closureNotes,
      meetingIncharge,
      initialMeetingInformationMedium,
      finalMeetingInformationMedium
    };
  })
);


  return {
    meetings: formattedMeetings,
    firstVisible: snapshot.docs[0],
    lastVisible: snapshot.docs[snapshot.docs.length - 1] || null,
  };
};


export const getMeetingStatusCounts = async ({
  meetingPersonId = "",
  assigneeId = "",
  startDate = "",
  endDate = "",
  initialInfoMedium = "",
  finalInfoMedium = "",
}) => {
  const constraints = [where("isEvent", "==", false)];

  if (meetingPersonId) {
    constraints.push(where("contactPerson", "==", doc(db, "contactPersons", meetingPersonId)));
  }

  if (assigneeId) {
    constraints.push(where("responsiblePerson", "==", doc(db, "users", assigneeId)));
  }

  if (initialInfoMedium) {
    constraints.push(where("initialMeetingInformationMedium", "==", initialInfoMedium));
  }

  if (finalInfoMedium) {
    constraints.push(where("finalMeetingInformationMedium", "==", finalInfoMedium));
  }

  if (startDate && endDate) {
    const startTimestamp = Timestamp.fromDate(
      moment(startDate, "MM-DD-YYYY").utcOffset("+05:30").startOf("day").toDate()
    );
    const endTimestamp = Timestamp.fromDate(
      moment(endDate, "MM-DD-YYYY").utcOffset("+05:30").endOf("day").toDate()
    );
    constraints.push(where("meetingStartTimestamp", ">", startTimestamp), where("meetingStartTimestamp", "<=", endTimestamp));
  }

  const counts = { completed: 0, notYetStarted: 0, cancelled: 0 };

  try {
    const snapshot = await getDocs(query(meetingsCollection, ...constraints));

    snapshot.docs.forEach((docSnap) => {
      const status = docSnap.data().meetingStatus;
      if (status === "COMPLETED") counts.completed += 1;
      else if (status === "NOT_YET_STARTED") counts.notYetStarted += 1;
      else if (status === "CANCELLED") counts.cancelled += 1;
    });
  } catch (error) {
    console.error("Error fetching meeting status counts:", error);
  }

  return counts;
};


export const meetingHistory = async ({ meetingId }) => {
  if (!meetingId) throw new Error("Meeting ID is required");
      console.log("meetCont"+ meetingId)

  const historyRef = collection(db, "meetings", meetingId, "history");
  const snapshot = await getDocs(historyRef);

  const historyRecords = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const response = await Promise.all(
    historyRecords.map(async (data) => {
      const historyTime = data.historyTimestamp.toDate().toLocaleDateString("en-GB");
      return {
        log: data.action,
        time: historyTime,
      };
    })
  );

  return response;
};



export const changeResponsiblePersonOfMeeting = async ({
  meetingId,
  newResponsiblePersonId,
}) => {
  try {
    if (!meetingId || !newResponsiblePersonId) {
      throw new Error("Meeting ID and new responsible person ID are required.");
    }

    const meetingRef = doc(db, "meetings", meetingId);
    const userRef = doc(db, "users", newResponsiblePersonId);
    // const userSnap = await getDoc(userRef)

    await updateDoc(meetingRef, {
      responsiblePerson: userRef,
      lastModifiedTimestamp: serverTimestamp(),
    });

  
  } catch (error) {
    console.error("Error changing responsible person:", error);
    return {
      success: false,
      message: error.message,
    };
  }
};



